import image_desenvolvimento_de_software from "../../../../assets/images/soluctions_images/image_desenvolvimento_de_software.png";
import image_consultoria_de_ti from "../../../../assets/images/soluctions_images/image_consultoria_de_ti.png";
import image_analise_de_dados from "../../../../assets/images/soluctions_images/image_analise_de_dados.png";
import image_desenvolvimento_de_site from "../../../../assets/images/soluctions_images/image_desenvolvimento_de_sites.png";
import image_automacao from "../../../../assets/images/soluctions_images/image_automacao.png";
import image_desenvolvimento_de_apps from "../../../../assets/images/soluctions_images/image_desenvolvimento_de_apps.png";

export const solutionsMapper = {
    title: "Soluções",
    sectionTitle: "Nossas \n Soluções para \n seus problemas",

    cards: [
        {
            id: 1,
            title_front: "Desenvolvimento de Software",
            description_front: "Desenvolvimento de software sob medida para resolver problemas reais do seu negócio.",
            image: image_desenvolvimento_de_software,
            title_back: "Construa soluções sob medida",
            description_back: "Desenvolvemos softwares personalizados do zero ou evoluímos sistemas que você já usa, sempre com foco em performance, segurança e manutenção simples. Ajudamos desde o desenho da solução até a entrega e sustentação, com integrações, APIs e automações do jeito certo. Você ganha um produto alinhado ao seu processo — não o contrário."
        },
        {
            id: 2,
            title_front: "Consultoria de TI",
            description_front: "Diagnóstico completo da sua TI para melhorar segurança, performance e organização.",
            image: image_consultoria_de_ti,
            title_back: "Traga clareza para sua infraestrutura",
            description_back: "Fazemos uma avaliação profunda do seu ambiente (servidores, rede, sistemas, acessos e processos) e apontamos riscos, gargalos e oportunidades de melhoria. Você recebe um plano prático e priorizado, com recomendações que cabem no seu cenário e no seu orçamento. Ideal para colocar a casa em ordem e ganhar previsibilidade."
        },
        {
            id: 3,
            title_front: "Análise de dados",
            description_front: "Coleta, processamento e análise de dados para transformar informação em decisão.",
            image: image_analise_de_dados,
            title_back: "Obtenha insights valiosos",
            description_back: "Coletamos, organizamos e analisamos seus dados para revelar oportunidades e reduzir desperdícios. Criamos dashboards claros e personalizados com Power BI e Tableau, e aplicamos análises avançadas (incluindo modelagem preditiva e machine learning) para apoiar previsões e decisões mais seguras. Quando faz sentido, integramos essas análises diretamente nos seus sistemas."
        },
        {
            id: 4,
            title_front: "Desenvolvimento de Sites",
            description_front: "Sites modernos, rápidos e responsivos, preparados para SEO e conversão.",
            image: image_desenvolvimento_de_site,
            title_back: "Tenha um site que realmente funciona",
            description_back: "Criamos sites com visual moderno, navegação simples e carregamento rápido — pensados para oferecer uma ótima experiência em qualquer dispositivo. Estruturamos páginas com boas práticas de SEO, performance e acessibilidade, para você ser encontrado e transmitir confiança. Se precisar, integramos formulários, automações e ferramentas de analytics."
        },
        {
            id: 5,
            title_front: "Automações",
            description_front: "Automatizamos processos para reduzir trabalho manual e aumentar eficiência.",
            image: image_automacao,
            title_back: "Automatize rotinas e ganhe tempo",
            description_back: "Mapeamos seus fluxos e automatizamos tarefas repetitivas para cortar retrabalho, erros e atrasos. Integramos sistemas, criamos rotinas inteligentes e conectamos dados entre ferramentas (ERP, planilhas, e-mail, WhatsApp, APIs e mais). Resultado: processos mais rápidos, equipe mais produtiva e operação mais confiável."
        },
        {
            id: 6,
            title_front: "Desenvolvimento de Aplicativos",
            description_front: "Apps mobile sob medida, com foco em performance, usabilidade e evolução contínua.",
            image: image_desenvolvimento_de_apps,
            title_back: "Leve sua solução para o mobile",
            description_back: "Desenvolvemos aplicativos para Android e iOS com experiência fluida e design focado no usuário. Construímos do MVP ao app completo, com integrações (APIs, pagamentos, login, notificações), analytics e suporte a publicação nas lojas. Tudo com uma base bem estruturada para escalar, manter e evoluir sem dor."
        }
    ],

    swiperConfig: {
        spaceBetween: 20,
        slidesPerView: 1,
        slidesPerGroup: 1,
        speed: 500,
        breakpoints: {
            0: { slidesPerView: 1.1, spaceBetween: 100, slidesOffsetBefore: 20, slidesOffsetAfter: 90 },
            400: { slidesPerView: 1.1, spaceBetween: 100, slidesOffsetBefore: 20, slidesOffsetAfter: 90 },
            464: { slidesPerView: 1.2, spaceBetween: 300, slidesOffsetBefore: 30, slidesOffsetAfter: 300 },
            501: { slidesPerView: 1.235, spaceBetween: 300, slidesOffsetBefore: 30, slidesOffsetAfter: 300 },
            650: { slidesPerView: 1.5, spaceBetween: 300, slidesOffsetBefore: 30, slidesOffsetAfter: 300 },
            768: { slidesPerView: 1.7, spaceBetween: 300, slidesOffsetBefore: 40, slidesOffsetAfter: 300 },
            858: { slidesPerView: 1.7, spaceBetween: 300, slidesOffsetBefore: 50, slidesOffsetAfter: 300 },
            950: { slidesPerView: 2.1, spaceBetween: 300, slidesOffsetBefore: 50, slidesOffsetAfter: 300 },
            1100: { slidesPerView: 2.2, spaceBetween: 300, slidesOffsetBefore: 60, slidesOffsetAfter: 300 },
            1280: { slidesPerView: 2.4, spaceBetween: 300, slidesOffsetBefore: 100, slidesOffsetAfter: 300 },
            1437: { slidesPerView: 2.6, spaceBetween: 300, slidesOffsetBefore: 100, slidesOffsetAfter: 300 },
            1600: { slidesPerView: 3.1, spaceBetween: 300, slidesOffsetBefore: 100, slidesOffsetAfter: 300 },
            1706: { slidesPerView: 3.3, spaceBetween: 300, slidesOffsetBefore: 100, slidesOffsetAfter: 300 },
            1886: { slidesPerView: 3.3, spaceBetween: 300, slidesOffsetBefore: 100, slidesOffsetAfter: 300 },
        }
    }
};
